export const generateCompleteCardPreview = (frontImage, backImage, options = {}) => {
  return null;
};

export const fitImageToArea = (image, area) => {
  return image;
};

export const calculateImageDimensions = (originalWidth, originalHeight, maxWidth, maxHeight) => {
  return {
    width: maxWidth,
    height: maxHeight,
  };
};

export const centerImageInArea = (image, area) => {
  return {
    ...image,
    x: area.left + (area.width - image.width) / 2,
    y: area.top + (area.height - image.height) / 2,
  };
};

export const resizeImageToFill = (image, area) => {
  return {
    ...image,
    width: area.width,
    height: area.height,
  };
};
